'use client';

import dynamic from 'next/dynamic';
import { ClerkErrorBoundary } from '@/components/clerk/ClerkErrorBoundary';

const WaitlistClient = dynamic(
  () =>
    import('@clerk/nextjs').then(mod => {
      const { Waitlist } = mod;
      return { default: () => <Waitlist /> };
    }),
  { ssr: false }
);

export default function WaitlistPage() {
  return (
    <div className="bg-muted flex w-full flex-1 items-center justify-center p-6 md:p-10">
      <ClerkErrorBoundary fallbackType="auth" componentName="Waitlist">
        <WaitlistClient />
      </ClerkErrorBoundary>
    </div>
  );
}
